const ProjectCollaboratorHelpers = {
    swr: {
        list: (projectId: string) => `/projects/${projectId}/collaborators`,
    },
};

export { ProjectCollaboratorHelpers };
